import type { Asset } from '../hooks/useAssets';

const IMAGE_EXTENSIONS = new Set([
  'jpg',
  'jpeg',
  'png',
  'gif',
  'webp',
  'bmp',
  'svg',
  'avif',
  'heic',
]);

export function isLikelyImageUrl(url?: string | null): boolean {
  if (!url) return false;

  const normalized = url.trim().toLowerCase();
  if (normalized.startsWith('data:image/')) return true;

  const pathname = normalized.split('#')[0].split('?')[0];
  const extensionMatch = pathname.match(/\.([a-z0-9]{2,5})$/);
  return !!extensionMatch && IMAGE_EXTENSIONS.has(extensionMatch[1]);
}

export function getAssetPreviewImageUrl(asset: Pick<Asset, 'thumbnailUrl' | 'previewUrl'>): string | null {
  if (asset.thumbnailUrl) return asset.thumbnailUrl;
  return isLikelyImageUrl(asset.previewUrl) ? (asset.previewUrl ?? null) : null;
}
